import { axiosInstance } from "../axios/axios"

export const getBusinessPlans = async () => {
    try {
        const result = await axiosInstance.get('/get-small-business-plans')
        const businessPLans = result.data.data
        return businessPLans
    } catch (error) {
        console.log(error)
    }
}